import { useCallback, useEffect, useState } from "react";
import { History, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, fmtDateTime } from "@/lib/api";
import { Panel } from "@/components/core/AppLayout";
import { Pager } from "@/components/core/Pager";

export const TIPO_EMAIL = {
  riepilogo: "Riepilogo", promemoria: "Promemoria soci", assegnazione: "Assegnazione task", cliente: "Promemoria cliente",
  anteprima_riepilogo: "Anteprima riepilogo", anteprima_promemoria: "Anteprima promemoria",
  portale_approvato: "Portale: approvazione", portale_modifiche: "Portale: modifiche", portale_upload: "Portale: materiali",
};
const STATUS = {
  inviato: "bg-emerald-50 text-emerald-700 border-emerald-200", errore: "bg-red-50 text-[#C8102E] border-red-200",
  saltato: "bg-slate-100 text-slate-600 border-slate-200", in_invio: "bg-amber-50 text-amber-700 border-amber-200",
};

export const EmailLog = ({ refreshKey }) => {
  const [data, setData] = useState(null);
  const [tipo, setTipo] = useState("tutti");
  const [page, setPage] = useState(1);
  const rows = data?.items || [];
  const load = useCallback(async () => {
    const r = await api.get("/notifiche/log", { params: { ...(tipo === "tutti" ? {} : { tipo }), page, page_size: 50 } });
    setData(r.data);
  }, [tipo, page]);
  useEffect(() => { load(); }, [load, refreshKey]);
  useEffect(() => { setPage(1); }, [tipo]);

  return (
    <Panel className="p-8 core-rise core-delay-4" data-testid="email-log-panel">
      <div className="flex items-center justify-between gap-4 mb-4">
        <h3 className="font-display text-xl font-extrabold text-[#0A1128] flex items-center gap-2"><History className="h-5 w-5 text-[#E8173A]" />Registro email automatiche</h3>
        <div className="flex gap-2">
          <Select value={tipo} onValueChange={setTipo}>
            <SelectTrigger className="rounded-xl w-56" data-testid="email-log-filter"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="tutti">Tutti i tipi</SelectItem>
              {Object.entries(TIPO_EMAIL).map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}
            </SelectContent>
          </Select>
          <Button variant="outline" onClick={load} className="rounded-full font-bold" data-testid="email-log-refresh"><RefreshCw className="h-4 w-4" /></Button>
        </div>
      </div>
      <div className="max-h-[420px] overflow-y-auto core-scroll">
        <table className="w-full text-sm" data-testid="email-log-table">
          <thead><tr className="text-left text-xs uppercase tracking-wider text-slate-600">
            <th className="py-2 pr-3">Data</th><th className="py-2 pr-3">Tipo</th><th className="py-2 pr-3">Destinatario</th><th className="py-2 pr-3">Stato</th><th className="py-2">Dettaglio</th>
          </tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-[#5FB3EA]/60 align-top" data-testid={`email-log-row-${r.id}`}>
                <td className="py-2 pr-3 whitespace-nowrap">{fmtDateTime(r.created_at)}</td>
                <td className="py-2 pr-3 font-semibold text-[#0A1128]">{TIPO_EMAIL[r.tipo] || r.tipo}</td>
                <td className="py-2 pr-3">{r.recipient || "—"}</td>
                <td className="py-2 pr-3"><span className={`text-[11px] font-bold rounded-full border px-2 py-0.5 ${STATUS[r.status] || STATUS.saltato}`}>{r.status}</span></td>
                <td className="py-2 text-slate-600">{r.error ? <span className="text-[#C8102E] font-semibold">{r.error}</span> : r.subject}</td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={5} className="py-6 text-center text-slate-600">Nessuna email registrata.</td></tr>}
          </tbody>
        </table>
      </div>
      <Pager data={data} page={page} setPage={setPage} testid="email-log-pager" />
    </Panel>
  );
};
